import { makeStyles } from '@rbx/ui';

const useReferenceMemberReturnsTableStyles = makeStyles()(() => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: '16px',
    },
    returnType: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      flexWrap: 'wrap',
    },
    returnLabel: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '100%',
    },
    description: {
      marginTop: '4px',
    },
  };
});

export default useReferenceMemberReturnsTableStyles;
